import React, { useEffect, useState } from "react";
import AttachmentTable from "~/Pages/Process/components/tabs/attachments/AttachmentTable";
import apiService from "~/services/service";
import { useParams } from "react-router-dom";
import { formatDate } from "~/utils/CSVFunctions";
import fileUploadLogo from "../../../assets/document.svg";
import { Card } from "primereact/card";
import API_ROUTES from "~/api-routes";
import DocumentConfirmationDialog from "~/components/confirmation-dialog/DocumentConfirmationDialog";
import TemporaryNotification from "~/components/toast-notification/AttachmentTemporaryNotification";
import Notification from "~/components/entities/notification/Notification";
import AttachmentSuccess from "~/components/toast-notification/AttachmentSuccess";
import { getFilenameFromReference } from "~/utils/fileUtils";

const SearchFIles = ({ children, states, rows, first, onPageChange }) => {
  const [loading, setLoading] = useState(false);
  const [fileData, setFileData] = useState([]);

  const [attachmentConfirmModal, setAttachmentConfirmModal] = useState(false);
  const [temporaryMessage, setTemporaryMessage] = useState("");
  const [isAttachmentLoader, setIsAttachmentLoader] = useState(false);
  const [selectedFile, setSelectedFile] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  const [restoreMessage, setRestoreMessage] = useState("");
  const [relatedId, setRelatedId] = useState("");

  const getAttachments = async (id) => {
    setLoading(true);
    const type =
      states.selectedService &&
      states.selectedService.name == "Core Entity Information"
        ? states.selectedProcess
          ? states.selectedProcess.type
          : states.selectedType && states.selectedType.type
        : states.selectedService &&
            states.selectedService.name == "Ad Hoc Requests" &&
            states.selectedRequestType
          ? "AD_HOC"
          : "PROCESS";
    setRelatedId(id);
    let files;
    if (!states.isPayslipFolder) {
      const { data } = await apiService(API_ROUTES.FETCH_DOCUMENTS, "GET", {
        replace: { id, type },
      });
      files = data;
    } else if (states.isPayslipFolder) {
      const { data } = await apiService(API_ROUTES.PAYSLIP_MATCHING, "GET", {
        replace: { id, status: "released" },
      });
      files =
        data?.map((data) => ({
          original_file_name: getFilenameFromReference(data?.file_reference),
          createdByData: data?.userData,
          size: data?.extracted_data?.fileSize,
          isPayslipData: true,
          category: "PAYSLIPS_AND_PAYROLL_REPORTS",
          subCategory: "PAYSLIPS",
          ...data,
        })) ?? [];
    }
    await setFileData(files);
    setLoading(false);
  };

  const { service_id, process_id, request_id } = useParams();
  useEffect(() => {
    if (states?.entity_detail?.name) {
      if (service_id) {
        getAttachments(
          process_id
            ? process_id
            : request_id
              ? request_id
              : states?.entity_detail?.id,
        );
      }
    }
  }, [states?.entity_detail, process_id, request_id]);

  const isCoreEntityOrRequestSelected =
    states.selectedService &&
    (states.selectedService.name === "Core Entity Information" ||
      states.selectedService.name === "Ad Hoc Requests");

  const handleDeleteDocument = (file) => {
    setAttachmentConfirmModal(true);
    setSelectedFile(file);
  };

  const relatedType =
    states.selectedService &&
    states.selectedService.name == "Core Entity Information"
      ? states.selectedProcess
        ? states.selectedProcess.type
        : states.selectedType && states.selectedType.type
      : states.selectedService &&
          states.selectedService.name == "Ad Hoc Requests" &&
          states.selectedRequestType
        ? "REQUEST"
        : "PROCESS";

  const handleConfirmDelete = async () => {
    setIsAttachmentLoader(true);
    setTemporaryMessage("");
    setRestoreMessage("");
    let isDeleted;
    if (!states?.isPayslipFolder) {
      const { status } = await apiService(
        API_ROUTES.DELETE_ATTACHMENT,
        "DELETE",
        {
          body: { blobUrl: selectedFile?.blob_url, name: selectedFile?.name },
          replace: {
            relatedId: process_id
              ? process_id
              : request_id
                ? request_id
                : states?.entity_detail?.id,
            relatedType:
              relatedType === "SHAREHOLDER" ? "SHAREHOLDERS" : relatedType,
          },
        },
      );
      isDeleted = status;
    } else if (states?.isPayslipFolder) {
      await apiService(API_ROUTES.PAYSLIP_MATCHING, "DELETE", {
        body: { processId: process_id },
        replace: { id: selectedFile?.id, status: "" },
      });
      isDeleted = true;
    }

    if (isDeleted) {
      setTimeout(async () => {
        setLoading(true);
        await getAttachments(
          process_id
            ? process_id
            : request_id
              ? request_id
              : states?.entity_detail?.id,
        );
        setAttachmentConfirmModal(false);
        setTemporaryMessage(
          `File ${states?.isPayslipFolder ? selectedFile?.extracted_data?.original_filename : selectedFile?.name} has been deleted.`,
        );
        setIsAttachmentLoader(false);
      }, 2000);
    }
  };

  const handleRestoreAttachment = async () => {
    setTemporaryMessage("");
    setRestoreMessage("");
    let isRestored;
    if (!states?.isPayslipFolder) {
      const { status } = await apiService(
        API_ROUTES.RESTORE_ATTACHMENT,
        "POST",
        {
          body: { blobUrl: selectedFile?.blob_url },
        },
      );
      isRestored = status;
    } else if (states?.isPayslipFolder) {
      const { data } = await apiService(
        API_ROUTES.RESTORE_PAYSLIP_MATCHING_RESULT,
        "PUT",
        {
          replace: { id: selectedFile?.id },
          body: {
            processId: process_id,
          },
        },
      );
      isRestored = data?.result;
    }
    if (isRestored) {
      setTimeout(async () => {
        await getAttachments(
          process_id
            ? process_id
            : request_id
              ? request_id
              : states?.entity_detail?.id,
        );
        setRestoreMessage(
          `${states?.isPayslipFolder ? selectedFile?.extracted_data?.original_filename : selectedFile?.name} has been restored.`,
        );
      }, 2000);
    }
  };

  return (
    <div className="search__file--container">
      {/*<div className="autocomplete__container">
        <span className="pi pi-search search__icon"></span>
        <AutoComplete
          value={fileName}
          className="w-full"
          suggestions={selectedItem}
          completeMethod={(e) => searchItem(e)}
          onChange={(e) => setFileName(e.value)}
          onSelect={handleSelectDocument}
          field="label"
          placeholder="Search files by name or service line"
        />
      </div>
      <div className="flex flex-wrap gap-2 mt-3 mb-3">
        {["category", "services", "subcategory"].flatMap((type) =>
          selectedList[type].map((item, index) => {
            return (
              <Chip
                key={`${type}-${item.label}-${index}`}
                label={item.label}
                className="custom-chip"
                removable
                onRemove={() =>
                  setSelectedList((prev) => ({
                    ...prev,
                    [type]: prev[type].filter((_, i) => i !== index),
                  }))
                }
              />
            );
          }),
        )}
      </div>*/}

      {children}

      <Notification
        successMessage={successMessage}
        setSuccessMessage={setSuccessMessage}
      />
      <AttachmentSuccess
        successMsg={restoreMessage}
        setMessages={setRestoreMessage}
      />
      <TemporaryNotification
        onUndo={handleRestoreAttachment}
        successMsg={temporaryMessage}
        setMessages={setTemporaryMessage}
      />
      {fileData?.length || loading ? (
        <AttachmentTable
          formatDate={formatDate}
          processAttachments={fileData}
          loadingAttachments={loading}
          first={first}
          rows={rows}
          onPageChange={onPageChange}
          showTypeColumn={!isCoreEntityOrRequestSelected}
          handleAttachmentDelete={handleDeleteDocument}
          attachmentConfirmModal={attachmentConfirmModal}
          setAttachmentConfirmModal={setAttachmentConfirmModal}
          handleConfirmDelete={handleConfirmDelete}
          isPayslipFolder={states?.isPayslipFolder}
          relatedType={relatedType}
          relatedId={relatedId}
        />
      ) : (
        <>
          {/*Object.values(selectedList).flat().length ? (
          <div className="empty__data__view--container">
            <img src={searchIcon} />
            <p>Sorry, we couldn’t find what you’re looking for.</p>
            <p>Try searching for something else or use a different tag.</p>
            <div className="suggested__tags--container">
              <p>Suggested Tags</p>
              <div>
                <Chip label="Passport" />
                <Chip label="Contract" />
                <Chip label="Invoice" />
                <Chip label="Other" />
              </div>
            </div>
          </div>*/}
          <Card>
            <div className="flex flex-column justify-content-center align-items-center p-5">
              <div className="no-documents-uploaded-section w-full gap-4">
                <img
                  src={fileUploadLogo}
                  alt="file-upload"
                  className="file-upload-logo"
                />
                <p className="add-new-entity-heading mb-0">
                  No documents have been added yet
                </p>
              </div>
            </div>
          </Card>
        </>
      )}
      {attachmentConfirmModal && (
        <DocumentConfirmationDialog
          visible={attachmentConfirmModal}
          closeModal={() => setAttachmentConfirmModal(false)}
          handleSave={handleConfirmDelete}
          isLoader={isAttachmentLoader}
        />
      )}
    </div>
  );
};

export default SearchFIles;
